import React from 'react';
import { Link } from 'react-router-dom';
import { showNotification } from './../../../utils';

/**
 * New BC replacements April 2025:
 * p9t10 -> p9t13 - UTHealth Houston | UTHealth Behavioral Sciences Business Card
 * 
 */

const TemplatesP9 = (props) => {
    const handleSearch = () => {
        if (props.search === '') {
            return showNotification('Enter a value', 'Enter a text to search', 'info');
        }

        props.history.push('/search/' + props.productType + '/' + props.search);
    };

    const keyPressHandler = (event) => {
        if (event.key === 'Enter') {
            if (props.search === '') {
                return showNotification('Enter a value', 'Enter a text to search', 'info');
            }

            props.history.push('/search/' + props.productType + '/' + props.search);
        }
    }

    let displayNewCards = false;
    if (props.user.username === 'hugh.admin' || props.user.username === 'utdemo') {
        displayNewCards = true;
    }

    return (
        <div className="templates-container">
            <div className="breadcrumbs">
                / <Link to="/uth">Main Categories</Link> / Business Cards
            </div>
            <div className="search-container">
                <div className="search-field">
                    <input
                        type="text"
                        placeholder="Search here..."
                        value={props.search}
                        onChange={(event) => props.setSearch(event.target.value)}
                        onKeyPress={keyPressHandler}
                    />
                    <select
                        value={props.productType}
                        onChange={(event) => props.setProductType(event.target.value)}
                    >
                        <option value="1">Cards</option>
                        <option value="17">Pocket Folders</option>
                        <option value="2">Letterheads</option>
                        <option value="3">Envelopes</option>
                        <option value="4">Notecards</option>
                        <option value="18">Notepads</option>
                        <option value="5">Forms</option>
                        <option value="7">Adult Apparel</option>
                        <option value="8">Promotional</option>
                        {/* <option value="16">Marketing</option> */}
                    </select>
                    <div className="button" onClick={handleSearch}>Search</div>
                </div>
            </div>
            <div className="templates-row">
                <div className="category">
                    <Link to="/template/9/1"><div className="image p9-t1"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | Cizik School of Nursing Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/1"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/9/2"><div className="image p9-t2"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | McGovern Medical School Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/2"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/9/3"><div className="image p9-t3"></div></Link>
                    <div className="title">
                        <div className="name">MD Anderson Cancer Center | UTHealth Houston Graduate School Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/3"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                {/* <div className="category">
                    <Link to="/template/9/4"><div className="image p9-t4"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | School of Biomedical Informatics Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/4"><button>Select</button></Link>
                        </div>
                    </div>
                </div> */}
                <div className="category">
                    <Link to="/template/9/11"><div className="image p9-t11"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | McWilliams School of Biomedical Informatics Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/11"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="templates-row">
                <div className="category">
                    <Link to="/template/9/5"><div className="image p9-t5"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | School of Dentistry Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/5"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                {/* <div className="category">
                    <Link to="/template/9/6"><div className="image p9-t6"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth | School of Public Health Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/6"><button>Select</button></Link>
                        </div>
                    </div>
                </div> */}
                <div className="category">
                    <Link to="/template/9/12"><div className="image p9-t12"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | School of Public Health Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/12"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/9/7"><div className="image p9-t7"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston General Card Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/7"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/9/8"><div className="image p9-t8"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston with Social Media Handles Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/8"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="templates-row">
                <div className="category">
                    <Link to="/template/9/9"><div className="image p9-t9"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | UTHealth Services Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/9"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/9/10"><div className="image p9-t10"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | UTHealth Behavioral Sciences Business Card</div>
                        <div className="button-container">
                            <Link to="/template/9/10"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                {displayNewCards && <div className="category">
                    <Link to="/template/9/13"><div className="image p9-t13"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | UTHealth Behavioral Sciences Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/13"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/14"><div className="image p9-t14"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston General Card Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/14"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
            </div>
            <div className="templates-row">
                {displayNewCards && <div className="category">
                    <Link to="/template/9/15"><div className="image p9-t15"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston with Social Media Handles Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/15"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/16"><div className="image p9-t16"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston Executive Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/16"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/17"><div className="image p9-t17"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | Cizik School of Nursing Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/17"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/18"><div className="image p9-t18"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | McGovern Medical School Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/18"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
            </div>
            <div className="templates-row">
                {displayNewCards && <div className="category">
                    <Link to="/template/9/19"><div className="image p9-t19"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | McWilliams School of Biomedical Informatics Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/19"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/20"><div className="image p9-t20"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | School of Dentistry Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/20"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/21"><div className="image p9-t21"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | School of Public Health Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/21"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
                {displayNewCards && <div className="category">
                    <Link to="/template/9/22"><div className="image p9-t22"></div></Link>
                    <div className="title">
                        <div className="name">UTHealth Houston | UTHealth Services Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/22"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
            </div>
            <div className="templates-row">
                {displayNewCards && <div className="category">
                    <Link to="/template/9/23"><div className="image p9-t23"></div></Link>
                    <div className="title">
                        <div className="name">MD Anderson Cancer Center | UTHealth Houston Graduate School Business Card <span style={{color: 'red'}}>(New)</span></div>
                        <div className="button-container">
                            <Link to="/template/9/23"><button>Select</button></Link>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    );
}

export default TemplatesP9;
